import { Navigate } from 'react-router-dom';
import { useMe } from '@/api/hooks/useAuth';
import { Skeleton } from '@/components/ui/skeleton';

export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { data, isLoading, isError } = useMe();

  if (isLoading) {
    return (
      <div className="space-y-4 p-6">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  if (isError || data?.is_admin !== 1) {
    return <Navigate to="/dashboard/projects" replace />;
  }

  return <>{children}</>;
}
